class StudyPlannerAPIService extends PlannerAPIService {

    saveProfile() {
        let json = plannerApplication.studyPlannerProfile.toJSON();
        this.helper.post('/sp2_save/' + this.brand + '/', {
                jsonData: json
            }
        )
    }

    shareProfile() {
        let json = plannerApplication.studyPlannerProfile.toJSON();
        this.helper.post('/sp2_share/' + this.brand + '/', {
                jsonData: json
            }
        )
    }

    loadProfile(guid, handler) {
        this.helper.get('/sp2_restore/' + guid + '/', {
            onResult: handler
        });
    }
}
